<template>
  <div :class="`bottom-sheet-container ${show ? 'no-overflow' : ''}`" :style="`z-index:${zIndex}`">
    <div :class="`sheet-body-wrapper ${show ? 'show' : ''}`">
      <div class="sheet-close-btn" @click="closeSheet">
        <i class="close" aria-hidden="true"></i>
      </div>
      <div class="sheet-body">
        <slot name="body"></slot>
      </div>
    </div>
    <div :class="`sheet-overlay ${show ? 'show' : ''}`" @click="closeSheet"></div>
  </div>
</template>

<script>
  export default {
    name: "BottomSheet",
    props: {
      show: {
        type: Boolean
      },
      zIndex: {
        type: Number,
        default: 100
      }
    },
    methods: {
      closeSheet() {
        this.$emit("close-sheet")
      }
    }
  }
</script>
<style lang="scss" scoped>
  .bottom-sheet-container {
    position: fixed;
    bottom: 0;
    left: 0;
    overflow: hidden;
    height: 0;
    .sheet-body-wrapper {
      width: 100vw;
      z-index: 1;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
      position: relative;
      padding: 16px;
      background: #ffffff;
      top: 100%;
      transition: all 0.3s ease-out;
      .sheet-close-btn {
        height: 42px;
        width: 42px;
        border-radius: 50%;
        border: 1px solid #e3e5e8;
        visibility: hidden;
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: absolute;
        top: -58px;
        background: #ffffff;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
        left: 0;
        right: 0;
        margin: 0 auto;
        i {
          font-size: 22px;
          -webkit-text-stroke: 3px white;
        }
      }
    }
    .close {
      background-image: url("../assets/cancel.png");
      cursor: pointer;
    }
    .sheet-overlay {
      display: none;
      background: rgba(68, 68, 68, 0.6);
      backdrop-filter: blur(4px);
      position: fixed;
      width: 100vw;
      height: 100vh;
      top: 0;
      left: 0;
    }
    .show {
      &.sheet-overlay {
        display: block;
      }
      &.sheet-body-wrapper {
        top: 0;
        .sheet-close-btn {
          visibility: visible;
        }
      }
    }
    &.no-overflow {
      overflow: visible;
      height: auto;
    }
  }
</style>
